module.exports = __webpack_public_path__ + "static/media/email.0c6e36dc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/email.svg
// module id = 861
// module chunks = 0